export enum ArchiveStatus {
  ARCHIVED = 'ARCHIVED',
  NON_ARCHIVED = 'NON_ARCHIVED',
  ALL = 'ALL'
}

export enum EgressType {
  ROOM = 'ROOM',
  PARTICIPANT = 'PARTICIPANT'
}

export enum SpaceUserRole {
  HOST = 'HOST',
  PARTICIPANT = 'PARTICIPANT'
}
